var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('h1',[_vm._v("Deposits")]),(_vm.loading)?_c('div',[_vm._v("\n    Loading...\n  ")]):_c('div',{staticClass:"margin-top"},[_c('table',[_vm._m(0),_c('tbody',_vm._l((_vm.data.deposits),function(row){return _c('tr',[_c('td',[_c('OrderLink',{attrs:{"id":row.id}})],1)])}),0)])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('thead',[_c('tr',[_c('th',[_vm._v("Order")])])])
}]

export { render, staticRenderFns }